module.exports = __webpack_public_path__ + "../assets/img/1bea87b33cefb1d9177afdc6d56e276c.svg";